export default __webpack_public_path__ + "static/media/thumb_3.086b66a0.webp";